import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import './Leads.css';

import axios from "axios";
import { FaEdit, FaTrashAlt, FaPlus, FaUserPlus } from "react-icons/fa";
import Profile from "../Profile/Profile";

import Breadcrumb from "../Breadcrumb";
import MetaHelmet from "../MetaHelmet";

const LeadsIndex = () => {
  const [leads, setLead] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Leads", path: "/leads" },
  ];

  const getUserDataFromCookies = () => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === "userData") {
        return JSON.parse(decodeURIComponent(value));
      }
    }
    return null;
  };

  const getToken = () => localStorage.getItem("token");

  const userData = getUserDataFromCookies();
  const userRoleId = userData ? userData.role_id : null;

  const leadStatusOptions = {
    1: "New",
    2: "Contacted",
    3: "Interested",
    4: "Converted",
  };

  const serviceInterestOptions = {
    1: "Website",
    2: "Google Listing",
    3: "E-Commerce",
  };

  const fetchLeads = async (query = "") => {
    const token = getToken();
    if (!token) {
      navigate("/");
      return;
    }
    try {
      const response = await axios.get(`${API_BASE_URL}get-leads/0`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          search: query,
          search: searchTerm,
        },
      });

      if (Array.isArray(response.data.leads)) {
        setLead(response.data.leads);
      } else {
        setLead([]);
        console.error("Response data.leads is not an array");
      }
    } catch (err) {
      setError("Failed to fetch leads data. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, [searchTerm, API_BASE_URL, navigate]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchTerm(query);
    fetchLeads(query);
  };

  const handleEdit = (id) => {
    navigate(`/lead/update/${id}`);
  };

  const handleDelete = async (id) => {
    const token = getToken();
    try {
      await axios.delete(`${API_BASE_URL}delete-lead/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLead(leads.filter((lead) => lead.id !== id));
    } catch (error) {
      setError("Error deleting lead. Please try again.");
      console.error("Error deleting lead:", error);
    }
  };

  const handleClient = async (id) => {
    const token = getToken();
    try {
      await axios.get(`${API_BASE_URL}get-lead/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLead(leads.filter((lead) => lead.id !== id));
      navigate(`/converttoclient/${id}`);
    } catch (error) {
      setError("Error converting lead to client. Please try again.");
      console.error("Error converting lead:", error);
    }
  };

  if (loading) {
    return (
      <div id="loader-wrapper">
        <span className="loader"></span>
      </div>
    );
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <>
      <MetaHelmet title={`Local Shouts | Leads`} />
      <div>
        <div className="leads-container">
          <Breadcrumb routes={routes} />

          <div className="d-flex bg-white p-3 rounded-2 white-box-shadow">
            <div class="form-group search-bar">
              <input
                type="text"
                placeholder="Search by leads name"
                value={searchTerm}
                onChange={handleSearch}
                class="form-control bg-light-gray"
              />
            </div>
            <div className="input-reset-div py-1 px-2 ms-3" onClick={() => setSearchTerm('')}>
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" class="input-reset">
                <path d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0" fill-rule="evenodd" />
              </svg>
            </div>
            <div className="action-bar ms-auto">
              <Link to="/leads/create" className="btn ls-btn create-btn">
                <FaPlus /> Create
              </Link>
            </div>
          </div>

          {/* {leads.length === 0 ? (
            <p>No leads found</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Business Name</th>
                  <th>Contact Name</th>
                  <th>Business Address</th>
                  <th>Service Interest</th>
                  <th>Lead Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead) => (
                  <tr key={lead.id}>
                    <td>{lead.business_name}</td>
                    <td>{lead.contact_name}</td>
                    <td>{lead.bussiness_address}</td>
                    <td>
                      {serviceInterestOptions[lead.service_interest] || "N/A"}
                    </td>
                    <td>{leadStatusOptions[lead.lead_status] || "Unknown"}</td>
                    <td>
                      <button onClick={() => handleEdit(lead.id)}>
                        <FaEdit /> Edit
                      </button>
                      {userRoleId === 1 && (
                        <button onClick={() => handleDelete(lead.id)}>
                          <FaTrashAlt /> Delete
                        </button>
                      )}

                      <button onClick={() => handleClient(lead.id)}>
                        <FaUserPlus /> Convert to client
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )} */}

          <div class="mt-5">
            {leads.length === 0 ? (
              <p>No leads found</p>
            ) : (
              <table class="table table-hover rounded-table white-box-shadow">
                <thead>
                  <tr>
                    <th>Business Name</th>
                    <th>Contact Name</th>
                    <th>Business Address</th>
                    <th>Service Interest</th>
                    <th>Lead Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead) => (
                    <tr key={lead.id}>
                      <td>{lead.business_name}</td>
                      <td>{lead.contact_name}</td>
                      <td>{lead.bussiness_address}</td>
                      <td>
                        {serviceInterestOptions[lead.service_interest] || "N/A"}
                      </td>
                      <td>{leadStatusOptions[lead.lead_status] || "Unknown"}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => handleEdit(lead.id)}
                        >
                          <FaEdit />
                        </button>
                        {userRoleId === 1 && (
                          <button
                            className="btn btn-danger ms-2"
                            onClick={() => handleDelete(lead.id)}
                          >
                            <FaTrashAlt />
                          </button>
                        )}

                        <button
                          className="btn btn-secondary ms-2"
                          onClick={() => handleClient(lead.id)}
                        >
                          <FaUserPlus />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

          <Profile setLead={setLead} />
        </div>
      </div>
    </>
  );
};

export default LeadsIndex;
